import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLiveMsg: {},
  isLiveMsgNotification: [],
  isLiveCampaignMsgCount: {},
  isLiveProductMsgCount: {},
};

const webSocketMsgSlice = createSlice({
  name: "webSocketMsgs",
  initialState,
  reducers: {
    setIsLiveMsg: (state, action) => {
      state.isLiveMsg = action.payload;
    },
    setIsLiveMsgNotification: (state, action) => {
      state.isLiveMsgNotification.push(action.payload);
    },
    setIsLiveCampaignMsgCount: (state, action) => {
      state.isLiveCampaignMsgCount = action.payload;
    },
    setIsLiveProductMsgCount: (state, action) => {
      state.isLiveProductMsgCount = action.payload;
    },

    // optional: clear notifications
    clearLiveMsgNotification: (state, action) => {
      const campaignId = action.payload;

      // Keep only messages that do NOT belong to this campaign
      state.isLiveMsgNotification = state.isLiveMsgNotification.filter(
        (msg) => msg.campaignId !== campaignId
      );
    },
    clearLiveMsgNotificationForCampaign: (state, action) => {
      const campaignId = action.payload;

      state.isLiveMsgNotification = state.isLiveMsgNotification.filter(
        (msg) => msg.campaignId !== campaignId
      );
    },

    // clearLiveMsgNotificationForProduct: (state, action) => {
    //   const { campaignId, productId } = action.payload;
    //   state.isLiveMsgNotification = state.isLiveMsgNotification.filter(
    //     (msg) => !(msg.campaignId === campaignId && msg.bookingId === productId)
    //   );
    // },
    clearLiveMsgNotificationForProduct: (state, action) => {
      const { campaignId, productId } = action.payload;

      state.isLiveMsgNotification = state.isLiveMsgNotification.filter(
        (msg) =>
          !(
            String(msg.campaignId) === String(campaignId) &&
            String(msg.bookingId) === String(productId)
          )
      );
    },

    // clearLiveMsgNotificationForProduct: (state, action) => {
    //   const { campaignId, productId } = action.payload;

    //   state.isLiveMsgNotification = state.isLiveMsgNotification.filter(
    //     (msg) => !(msg.campaignId === campaignId && msg.productId === productId)
    //   );
    // },
  },
});

export const {
  setIsLiveMsg,
  setIsLiveMsgNotification,
  clearLiveMsgNotification,
  setIsLiveProductMsgCount,
  setIsLiveCampaignMsgCount,
  clearLiveMsgNotificationForCampaign,
  clearLiveMsgNotificationForProduct,
} = webSocketMsgSlice.actions;

export default webSocketMsgSlice.reducer;
